// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rules {
  max-width: 80vw;
  margin: 2rem auto;
  border: 2px dashed gainsboro;
  padding: 2rem;
  border-radius: 12px; }
  .Rules .btn {
    display: inline-block; }
    .Rules .btn.right {
      float: right;
      font-size: 1.5rem;
      padding: 0 1rem; }
`, "",{"version":3,"sources":["webpack://./src/routes/Rules.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BCJqB;EDKrB,aAAa;EACb,mBAAmB,EAAA;EALrB;IAQI,qBAAqB,EAAA;IARzB;MAWM,YAAY;MACZ,iBAAiB;MACjB,eAAe,EAAA","sourcesContent":["@import \"./../style/colors\";\n\n.Rules {\n  max-width: 80vw;\n  margin: 2rem auto;\n  border: 2px dashed $primaryGrey;\n  padding: 2rem;\n  border-radius: 12px;\n\n  .btn {\n    display: inline-block;\n\n    &.right {\n      float: right;\n      font-size: 1.5rem;\n      padding: 0 1rem;\n    }\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
